import axios from 'axios'
import { getAPIService } from '../../getServerHost'
import { roomId } from '../types'

export const getRoomDetail = async (id: roomId) => {
  const response = await axios.get(`${getAPIService}/v2/api/rooms/${id}`)
  return response.data
}
